import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Global Config',
  share: {
    namespace: 'globalConfig',
    merge: (previous, next) => ({ ...previous, ...next }),
  },
  make: () => ({
    key: [],
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: '/configurations/global',
        query: { returnDisabledFields: true },
      }),
  }),
});
